<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="بعد-أيام-قليلة">
<h1><span dir="rtl">بعد أيَّامٍ قليلةٍ</span></h1>
<p><span dir="rtl">انصرفَ الجميع وبقي الاثنان في المنزل الصّغير الَّذي يجتَمعون فيه بعد أن هدأَتِ الأوضاع.</span></p>
<p><span dir="rtl">- اتَّصل مختارٌ وطمأنني، لم يعد هناك أيُّ شيءٍ يدعو للقلق يا صديقي، استطاع بطريقته الخاصّة أن يضلِّلهم باستغلال منصبه كضابطٍ في الأمن.</span></p>
<p><span dir="rtl">ردّ عزّام: لقد فاتني الكثير.</span></p>
<p><span dir="rtl">قال عليّ:</span></p>
<p><span dir="rtl">- تُعوِّضها مُستقبلًا!</span></p>
<p><span dir="rtl">- ثمَّ سكتَ عليٌّ وهو ينظر إلى عزّام وقد أنهكَت الحُمّى جسده النَّحيل.</span></p>
<p><span dir="rtl">سأله عزّام: أتريدُ أن تقول شيئًا؟</span></p>
<p><span dir="rtl">- الحمد لله على سلامتك يا صديقي.</span></p>
<p><span dir="rtl">- بسبب هذه الحمّى اللَّعينة فاتتني كلُّ تلك الأحداث.</span></p>
<p><span dir="rtl">- ما سبب هذه الحمّى يا ترى؟</span></p>
<p><span dir="rtl">فكّر عزّام ولم يجد الجّواب.</span></p>
<p><span dir="rtl">أجاب عليّ: أمّك!</span></p>
<p><span dir="rtl">- أمّي!</span></p>
<p><span dir="rtl">- هذه الحمّى عبارةٌ عن رَدّة فعلٍ على الحرمان الَّذي تعيشه منذُ انفصالِها عنكم.</span></p>
<p><span dir="rtl">ضحِكَ وقالَ: كيف تفسّر الأمور يا عليّ؟!</span></p>
<p><span dir="rtl">- ألَا تشتاق لها؟ ألا تحتاجها بجانبك؟</span></p>
<p><span dir="rtl">- كثيرًا!</span></p>
<p><span dir="rtl">- إذًا!</span></p>
<p><span dir="rtl">- لكن هذا ليس سبب مرضي، لأنّني أزورها باستمرارٍ كلَّما اشتقتُ لها.</span></p>
<p><span dir="rtl">- قلتَ إنّك تزورها!</span></p>
<p><span dir="rtl">- نعم، أزورها، ولا تنظر إليّ هكذا! لن أدخل بيت ذلك الباشا أبدًا.</span></p>
<p><span dir="rtl">- أعرف، لكن إلى متى ستظلّ هكذا تقابل أمّك عند بوّابة القصر وفي الحدائق والأماكن العامة؟</span></p>
<p><span dir="rtl">انزعج عزّام من كلامه.</span></p>
<p><span dir="rtl">- حسنًا، لن أزعجك اليوم بهذا الأمر، لكن هذا لا يعني أنّ الموضوع منتهٍ.</span></p>
<p><span dir="rtl">- عليّ، أرجوك! أغلق هذا الموضوع.</span></p>
<p><span dir="rtl">- أعرف جيّدًا مدى تعلُّقك بوالدتك، وابتعادُك عنها هو سبب حُزنك ومَرضك المستمرّ، فلِمَ كلُّ هذا العِناد يا صديقي؟!</span></p>
<p><span dir="rtl">ظلّ عزّام ساكتًا.</span></p>
<p><span dir="rtl">- وأيضًا لقد تغيَّر الباشا كثيرًا، لم يعد يمانع لو رجعتْ أمّك لعائلتها، والفضل يعود لك في ذلك، لذا يكفي.</span></p>
<p><span dir="rtl">- لا، أنا لا أستطيع نسيان ما فعله بحقِّ عائلتي.</span></p>
<p><span dir="rtl">- ما ذنبُ أُمّك وأبيك لتحرمهم من بعض؟</span></p>
<p><span dir="rtl">- كما قلتَ، لم يعد يمنعُها أن ترجع إلى زوجها وأولادها، لكنَّها اختارت أن تبقى إلى جانبه وأن تعمل في مصنعه، هذه المرّة اختارت الباشا بإرادتها وعلى حساب عائلتها.</span></p>
<p><span dir="rtl">- لا تنسَ أنَّه والدها!</span></p>
<p><span dir="rtl">- لا يستحقُّ بِرَّها.</span></p>
<p><span dir="rtl">- عزّام! هل أنتَ مدركٌ أنّك أصبحت العائق الوحيد أمام اجتماعِ عائلتك من جديدٍ برفضك وعنادك؟</span></p>
<p><span dir="rtl">- أصبحتُ أنا المخطئ في حقِّ عائلتي الآن! أحسنتَ يا صاحبي.</span></p>
<p><span dir="rtl">- أوف يا عزّام.</span></p>
<p><span dir="rtl">- وأيضًا مَن أولى باهتمامها، نحن أم هذا الباشا الَّذي شتَّت عائلتها؟</span></p>
<p><span dir="rtl">لم يردّ.</span></p>
<p><span dir="rtl">- وأنتَ! منذُ متى صِرت تدافع عن الباشا؟</span></p>
<p><span dir="rtl">- لست أدافع عنه، ولكن..</span></p>
<p><span dir="rtl">- عليّ! أرجوكَ لنغيَّر الموضوع.</span></p>
<p><span dir="rtl">قالها ثمَّ قام من مكانه وجلس بالقرب من الموقد ووضع سخّان الشّاي على النّار وقال:</span></p>
<p><span dir="rtl">- ماذا تنوي أن تفعل الآن؟ أعني بشأن شقيقة المرحوم قاسم.</span></p>
<p><span dir="rtl">ردّ عليّ: لا أعرف ماذا أفعل حقًّا، عقلي مشوَّش.</span></p>
<p><span dir="rtl">نظر إليه متسائلًا:</span></p>
<p><span dir="rtl">- أليسَ غريبًا أنَّه طوال فترة معرفتنا به لم نعرف شيئًا عن حياته الخاصَّة أو عائلته؟</span></p>
<p><span dir="rtl">- لو كنّا نعرف على الأقل شخصًا من عائلة قاسم لما جلسنا هنا نفكّر لساعاتٍ في حلٍّ مناسبٍ لموضوع شقيقته.</span></p>
<p><span dir="rtl">- هل يخطر في بالك شيءٌ معيَّنٌ؟</span></p>
<p><span dir="rtl">فكّر عليّ قليلًا ثمَّ قال: حاليًا ستبقى عندي إلى أن أجد لها مكانًا مناسبًا.</span></p>
<p><span dir="rtl">سكتَ عليّ، ثمَّ استأنف كلامه: ما رأيك في المدرسة الداخليَّة يا عزّام؟</span></p>
<p><span dir="rtl">- فكرة المدرسة الدّاخلية ممتازةٌ، خاصّةً وأنت تعيش وَحْدك.</span></p>
<br/>
<p style="text-align:Center;"><span dir="rtl">*****</span></p><br/>
<p><span dir="rtl">كان عليّ في الخامسة عشرة من عمره عندما تعرَّف على عائلة الأستاذ صباح الحمداني، قَدِم من بلدته بعد وفاة جدِّه ليستقرَّ في بغداد، عاش في البداية في المنزل الَّذي تركه له والده الَّذي هاجر إلى إسطنبول، ثمَّ ما لَبِث أن انتقل للعيش في منزل الأستاذ مع أبنائه، ويعتبَر الأستاذ صباح الأب الرّوحيَّ لعَليّ الرَّشيد ورفاقه.</span></p>
<p><span dir="rtl">قبل ستَّة أشهرٍ من اليوم غادر عليّ بيت الأستاذ، وبدأ ينظّم حياته ويستعدّ لترك حياة العزوبيَّة ويتوِّج علاقة الحبِّ الَّتي تربطه بحفيدة رفعت باشا الهاشم بالزّواج، ويعتبر الباشا من أشهر رجال الأعمال في البلد، والرّجل الموثوق في البلاط الملكيّ سابقًا، قبل انخراط حفيده في السّياسات المُعادية للحُكم مثل والده مع اختلافٍ واحدٍ وهو؛ اختيار الأستاذ صباح الطرُق السّلميّة على عكس ابنه الَّذي اختار حمل السّلاح ضدَّ الحكومة.</span></p>
<p><span dir="rtl">مأمون: اعتُقِل عزّام بعد أن قرّر تحدّي قراراتِ الحكومة والنُّزول مع رفاقه وكَسْر أقفال الصُّحف المُغلقة.</span></p>
<p><span dir="rtl">نزل الخبر كالصّاعقة على رفعت الهاشم وابنته.</span></p>
<p><span dir="rtl">أمّا الأستاذ فقد كان أكثر صلابةً بالرّغم من أنّهم اقتادوا ابنه وصديقيه من أمامه، خاف الأستاذ بعد اعتقال عزّام أن يُجبَرَ تحت التَّعذيب بالاعتراف عن أسماء باقي أصدقائه، ولتجنُّب هذا الأمر قام بتحذير الشّباب:</span></p>
<p><span dir="rtl">- أُلقِي القبض على اثنين من رفاقكم وهما عامر وحمّادي، أمّا كاظم فقد استطاع الهرب، تعرف كاظم جيّدًا؛ إنَّه خفيفٌ وسريع الحركة، يعرف جميع مخارج ومداخل السّوق ومن الصّعب الإمساك به.</span></p>
<p><span dir="rtl">عليّ: وعزّام! كيفَ سلّم نفسهُ؟ لماذا لم يهرب معه؟</span></p>
<p><span dir="rtl">عسّاف: لا أعرفُ، لقد صُدِمنا بتصرّفه، مع أنَّه كان بإمكانه الهروب مع كاظم.</span></p>
<p><span dir="rtl">أخذ عليّ يمسح وجهه بكفّيه وأخذ نفسًا عميقًا وزفرَ بقوَّةٍ، اقترب منه حازم قائلًا: اهدأ!</span></p>
<p><span dir="rtl">وقبل أن يُكمل قطعَ كلامَهُ صوت الباب القويّ ليلتفت الجميع ناحية الباب وعلاماتُ الخوف والارتباك بادِيَةٌ على وجوهِهم، يهرع عليّ بسرعةٍ نحو المكتب ويسحب الدُّرج ويُخرج مسدّسًا، وما هي إلّا ثوانٍ حتّى أخرج الجميع أسلحتهم المخبّأة وصوّبوها نحو الباب، ولكنَّ الهدوء الَّذي عند الباب بدَّد شُكوكهم، لهذا بادر عليّ بمحاولة اكتشاف صاحب الصَّوت القادم من الخارج.</span></p>
<p><span dir="rtl">يقول عليٌّ مُندهِشًا: كاظم! الحمد لله أني رأيتكَ بخير.</span></p>
<p><span dir="rtl">دخلَ كاظم وأغلق الباب.</span></p>
<p><span dir="rtl">قال رشيد: ماذا سنفعل يا عليّ؟</span></p>
<p><span dir="rtl">- نغادر المدينةَ كما طلب منّا الأستاذ.</span></p>
<p><span dir="rtl">نصرت: لكن إلى أين؟</span></p>
<p><span dir="rtl">عليّ: إلى بيتِ جدّي.</span></p>
<p><span dir="rtl">عزّت: هل سنكون في مأمنٍ هناك؟</span></p>
<p><span dir="rtl">عليّ: البيت بعيدٌ وفي مكانٍ مهجورٍ وينفعُ للاختباء.</span></p>
<p><span dir="rtl">وَضَع عليّ السّلاح تحت الحزام ولبس المعطف.</span></p>
<p><span dir="rtl">يسألهُ حازم: إلى أين؟</span></p>
<p><span dir="rtl">عليّ: سأذهبُ إلى بيت الأستاذ صباح، يجب أن أراه.</span></p>
<p><span dir="rtl">رشيد: لكنَّ المنزل مراقبٌ!</span></p>
<p><span dir="rtl">عليّ: أعرف طريقةً لدخول المنزل دون أن يلاحظ أحدٌ ذلك.</span></p>
<p><span dir="rtl">رشيد: رجال الأمن في الشّوارع.</span></p>
<p><span dir="rtl">عليّ: لا تقلق.</span></p>
<p><span dir="rtl">همّ عليّ بالخروج:</span></p>
<p><span dir="rtl">- تذكّرتُ، قبل أن أنسى؛ اذهَب إلى العمّ ناجي واسأله إذا كان يستطيع أن يُعيرنا الشّاحنة، ولا تنسَ تسليم مفاتيح المكان له أيضًا، نلتقي بعد منتصف اللّيل بالقُرب من المحطة، إذا تأخّرتُ غادِروا العاصمة بدوني.</span></p>
<p><span dir="rtl"><br/>
</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch011.vue?b4f1465e